import ApiService from "./api.service";

export default function MessageService() {}

MessageService.createMessage = (data) => {
  return ApiService.post(`/messages`, data);
};
